<template>
<div>
  <div v-if="getTransporters.length > 0">
    <div v-if="getTransporters.length === 1">
      <input name="transport_id"
             :value="getTransporters[0].transporter_id"
             type="hidden">
      <div v-if="shouldEnableSmartPointSelection(getTransporters[0].class_name)">
        <smart-point-selection></smart-point-selection>
      </div>
      <div v-if="transporterSmartPointsApiError(getTransporters[0].class_name)" class="smart-point-api-error">
        <span v-html="transporterSmartPointsApiErrorMessage(getTransporters[0].class_name)" class="smart-point-api-error-text"></span>
      </div>
    </div>
    <div v-else>
      <div v-for="transporter in getTransporters" :key="transporter.transporter_id" class="custom-control custom-radio">
        <input name="transport_id"
               v-bind:value="transporter.transporter_id"
               @input="$emit('input', $event.target.value)"
               @click="onClickTransporter()"
               @change="onChangeTransporter($event)"
               type="radio"
               :id="'courierRadio' + transporter.transporter_id"
               class="custom-control-input"
               :disabled="transporterSmartPointsApiError(transporter)"
               v-model="selectedTransporter">
        <label class="custom-control-label transporter_label" :for="'courierRadio' + transporter.transporter_id">
          {{ transporter.name }}
        </label>
        <div v-if="shouldEnableSmartPointSelection(transporter.class_name)">
          <smart-point-selection></smart-point-selection>
        </div>
        <div v-if="transporterSmartPointsApiError(transporter.class_name)" class="smart-point-api-error">
          <span v-html="transporterSmartPointsApiErrorMessage(transporter)" class="smart-point-api-error-text"></span>
        </div>
        <div v-if="getSelectedSmartPoint.id !== 0 && shouldEnableSmartPointSelection(transporter.class_name)" class="smart-point-selected">
          <span class="smart-point-selected-text" @click="smartPointClickEvent()">
            {{ t('checkout.transporters.smart_point.selected.locker') }}
            <span class="smart-point-selected-text-point_name">
              {{ getSelectedSmartPoint.name }}
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>

  <div v-show="getSelectedTransporterSmartPointEnable">
    <GenericModal
      :unique-id="`smartPointModal${getSelectedTransporterClassName}`"
      :ref="`smartPointModal${getSelectedTransporterClassName}`"
      :has-header="false"
      :has-footer="false"
      :close-dispatch-event="'smartPointMapCloseEvent'"
      :open-dispatch-event="'smartPointMapOpenEvent'"
      :close-btn-color="'#ef1b1b'"
    >
      <smart-point-map
        smart-points-getter="getSelectedTransporterSmartPoints"
        :use-clusters="true"
      >
      </smart-point-map>
    </GenericModal>
  </div>
</div>

</template>

<script>
import { filter, find } from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import GenericModal from './presentation/GenericModal'
import SmartPointMap from './SmartPoint/SmartPointMap'
import SmartPointModel from './SmartPoint/SmartPointModel'
import SmartPointSelection from './SmartPoint/SmartPointSelection'

export default {
  name: 'AdvOrderTransporters',
  components: {
    SmartPointSelection,
    SmartPointMap,
    GenericModal
  },
  props: {
    country: { type: String, default: '' },
    county: { type: String, default: '' },
    postal: { type: String, default: '' }
  },
  data () {
    return {
      version: '0.0.1',
      selectedTransporter: null
    }
  },
  watch: {
    country (val) {
      this.initTransporters()
    },
    county (val) {
      this.initTransporters()
    },
    postal (val) {
      this.initTransporters()
    },
    cartTotalWithDiscount (val) {
      this.initTransporters()
    },
    cartProductWeightTotal (val) {
      this.initTransporters()
    },
    getTransporters (val) {
      this.checkTransportersDataChange()
    },
    selectedTransporter (val) {
      this.checkTransporterSmartPointsApiError()
    }
  },
  computed: {
    ...mapGetters([
      'getTransporters',
      'cartTotalWithDiscount',
      'cartProductWeightTotal',
      'getSelectedTransporterId',
      'getSelectedTransporterSmartPointEnable',
      'getSelectedTransporterClassName',
      'getSelectedTransporterSmartPoints',
      'getSelectedSmartPoint',
      'getSmartPointIsSelected',
      'getSelectedTransporterSmartPointsApiError',
      'getSelectedTransporterSmartPointsApiErrorMessage',
      'getSelectedTransporterObject'
    ])
  },
  mounted () {
    if (this.country && this.county && this.postal) {
      this.initTransporters()
    }
  },
  methods: {
    ...mapActions(['getTransporterData']),
    initTransporters () {
      this.getTransporterData({
        country: this.country,
        county: this.county,
        postal: this.postal,
        totalWithVat: this.cartTotalWithDiscount,
        weight: this.cartProductWeightTotal
      })
    },
    checkTransportersDataChange () {
      if (this.getTransporters.length === 0) {
        return
      }

      if (!this.selectedTransporter) {
        this.$emit('set-input', this.getTransporters[0].transporter_id)
        this.selectedTransporter = this.getTransporters[0].transporter_id
        return
      }

      const transporterExist = this.getTransporters.find(item => item.transporter_id === this.selectedTransporter)
      if (!transporterExist) {
        this.$emit('set-input', this.getTransporters[0].transporter_id)
        this.selectedTransporter = this.getTransporters[0].transporter_id
      }
    },
    async onClickTransporter () {
      await this.$store.dispatch('smartPointUncheck')
    },
    isSelectedTransporterByClassName (className) {
      if (this.getTransporters.length <= 0) {
        return false
      }
      const selectedTransporter = find(this.getTransporters, (transporter) => {
        return transporter.transporter_id === this.getSelectedTransporterId
      })
      const selectedTransporterClassName = selectedTransporter.class_name
      return className === selectedTransporterClassName
    },
    shouldEnableSmartPointSelection (transporterClassName) {
      return this.getSelectedTransporterSmartPointEnable && this.getSelectedTransporterSmartPoints.length > 0 && transporterClassName === this.getSelectedTransporterClassName
    },
    onChangeTransporter ($event) {
      this.$emit('change', $event)
      this.$store.dispatch('setSelectedSmartPoint', new SmartPointModel())
    },
    checkTransporterSmartPointsApiError () {
      if (this.getSelectedTransporterSmartPointsApiError && this.getSelectedTransporterObject.deliveryOptionType === '2') {
        const selectedTransporter = filter(this.getTransporters, (transporter) => {
          return !this.transporterSmartPointsApiError(transporter.class_name)
        })
        if (selectedTransporter.length === 0) {
          return
        }
        this.selectedTransporter = selectedTransporter[0].transporter_id
        this.$emit('set-input', selectedTransporter[0].transporter_id)
      }
    },
    transporterSmartPointsApiError (transporter) {
      if (transporter.deliveryOptionType !== '2') {
        return false
      }
      const data = this.$store.getters.getAllTransporterSmartPoints[transporter.class_name]
      if (data === undefined) {
        return false
      }
      if (data.responseError) {
        return true
      }
    },
    transporterSmartPointsApiErrorMessage (transporter) {
      if (transporter.deliveryOptionType !== '2') {
        return ''
      }
      const data = this.$store.getters.getAllTransporterSmartPoints[transporter.class_name]
      if (data === undefined) {
        return ''
      }
      return data.responseError
    },
    async smartPointClickEvent () {
      await this.$store.dispatch('smartPointClickEvent').then(
        () => this.$refs[`smartPointModal${this.getSelectedTransporterClassName}`].openModal()
      )
    }
  }
}
</script>
